import React from 'react';
import Tag from 'src/modules/shared/components/atoms/tag';
import type { IntegrationConnectionUiStatus } from 'src/modules/shared/types/integration-connection-status.type';
import { IntegrationConnectionHealthStatus } from 'src/api/generated';
import type { TranslationKey } from 'src/modules/shared/types/i18n/translation-keys.type';
import type { I18nContextValue } from 'src/modules/shared/types/i18n/i18n.type';
import {
  getIntegrationHealthLabelKey,
  getIntegrationHealthVariant,
  getIntegrationStatusLabelKey,
  getIntegrationStatusVariant,
} from 'src/modules/settings/utils/integration-connection-status.util';

interface IntegrationConnectionBadgesProps {
  status: IntegrationConnectionUiStatus;
  healthStatus: IntegrationConnectionHealthStatus | null;
  t: I18nContextValue['t'];
}

const translate = (t: I18nContextValue['t'], key: TranslationKey): string =>
  t(key);

/**
 * Renders standardized connection status and health badges.
 */
export const IntegrationConnectionBadges: React.FC<
  IntegrationConnectionBadgesProps
> = ({ status, healthStatus, t }) => {
  return (
    <div className="flex items-center gap-2">
      <Tag
        content={translate(t, getIntegrationStatusLabelKey(status))}
        variant={getIntegrationStatusVariant(status)}
        appearance="soft"
        size="sm"
      />
      {healthStatus ? (
        <Tag
          content={translate(t, getIntegrationHealthLabelKey(healthStatus))}
          variant={getIntegrationHealthVariant(healthStatus)}
          appearance="soft"
          size="sm"
        />
      ) : null}
    </div>
  );
};
